const betaURL = require("app/util/config/beta-url");
const CardWithLoader = require("../Dashboard/card-with-loader");
const Summary = require("../Dashboard/summary");

const Reflux = require("reflux");
const ProfitableDealOriginsStore = require("../../stores/profitable-deal-origins-store");
const ProfitableDealOriginsActions = require("../../actions/profitable-deal-origins-actions");
const Chart = require("../Dashboard/Chart/chart");
const currencyFormatter = require("app/util/formatter/currency");

const moment = require("moment");

const ProfitableDealOriginsWidget = React.createClass({
  mixins: [Reflux.ListenerMixin],

  getInitialState: function() {
    return ProfitableDealOriginsStore.getInitialState();
  },

  componentDidMount: function() {
    this.listenTo(ProfitableDealOriginsStore, this.setState);
    this.refresh();
  },

  componentDidUpdate: function(prevProps) {
    if (prevProps != this.props) {
      this.refresh();
    }
  },

  refresh: function() {
    ProfitableDealOriginsActions.fetchData(
      this.props.period,
      this.props.users,
      this.props.funnel
    );
  },

  getItemFromElement: function(element) {
    return element && this.state.data.profitableOrigins[element._index];
  },

  isInteractiveItem: function(item) {
    return item && !item.rest;
  },

  getDetailsUrl: function(id) {
    const dateFormat = "YYYY-MM-DD";
    const startDate = this.props.period.startDate.format(dateFormat);
    const endDate = this.props.period.endDate.format(dateFormat);

    let searchParams = new URLSearchParams();

    if (id) {
      searchParams.append("origemLead", id);
    }else{
      searchParams.append("origemLead", -1);
    }
    
    searchParams.append("sn", 2);
    searchParams.append("dci", startDate);
    searchParams.append("dcf", endDate);
    searchParams.append("qpp", 25);

    if (this.props.selectedUser)
      searchParams.append("ur", this.props.selectedUser);
    if (this.props.selectedTeam)
      searchParams.append("team", this.props.selectedTeam);
    if (this.props.funnel)
      searchParams.append("funil", this.props.funnel);

    return `${betaURL()}/deals?${searchParams}`;
  },

  render: function() {
    return (
      <CardWithLoader
        loading={this.state.loading}
        failed={this.state.failed}
        onRetry={this.refresh}
        title={
          <p>Origens que trazem mais receitas</p>
        }
        className="grid-item-col-2"
        footer={
          <span className="text-muted">
            Clique em um segmento para ver a lista de negócios
          </span>
        }
      >
        <div className="d-g grid-2 gg-20">
          <div className="grid-item-col-2">
            <div className="grid-item-col-2">
              <Chart
                type="pie"
                datasets={[{
                  data: this.state.data.profitableOrigins.map(item => (
                    item.total_amount
                  ))
                }]}
                labels={this.state.data.profitableOrigins.map(item => (
                  item.name || "Sem Origem"
                ))}
                options={{
                  onHover: (event, [element]) => {
                    let item = this.getItemFromElement(element);

                    if (this.isInteractiveItem(item)) {
                      event.target.style.setProperty("cursor", "pointer");
                    } else {
                      event.target.style.removeProperty("cursor");
                    }
                  },
                  onClick: (_, [element]) => {
                    let item = this.getItemFromElement(element);

                    if (this.isInteractiveItem(item)) {
                      window.open(this.getDetailsUrl(item.id), "_blank");
                    }
                  },
                  tooltips: {
                    callbacks: {
                      title: (tooltipItem, data) => data.labels[tooltipItem[0].index],
                      label: (tooltipItem, data) => {
                        const dataset = data.datasets[0];

                        const value = this.state.data.profitableOrigins[tooltipItem.index].total_amount;
                        const visibleTotal = dataset._meta[Object.keys(dataset._meta)[0]].total;
                        const percentage = visibleTotal === 0
                          ? "0%"
                          : ((value / visibleTotal) * 100).toFixed(1) + "%";

                        const formattedValue = currencyFormatter.formatCentsToCurrency(value);
                        const count = this.state.data.profitableOrigins[tooltipItem.index].count;

                        return ([
                          `${formattedValue} (${percentage})`,
                          `${count} negócios`
                        ]);
                      }
                    }
                  }
                }}
              />
            </div>
          </div>
        </div>
      </CardWithLoader>
    )
  }
});

module.exports = ProfitableDealOriginsWidget;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/profitable-deal-origins-widget.jsx